import { ApiImpediment } from '../api-types/impediment.api';
import { Impediment, ImpedimentGroup } from '../app-types/impediment.app';

export function transformApiImpedimentToAppImpediment(apiImpediment: ApiImpediment): Impediment {
	return {
		id: apiImpediment.id,
		description: apiImpediment.designation,
	};
}

/**
 * Converts the impediments returned by the API with their group info to a list of groups containing their impediments.
 * @param input response from API
 */
export function transformApiImpedimentsToAppImpedimentGroupsWithImpediments(input: ApiImpediment[]): ImpedimentGroup[] {
	const groupsMap = new Map<number, ImpedimentGroup>();

	input.forEach((apiImpediment) => {
		const groupId = apiImpediment.assignmentImpedimentGroup.id;
		let group = groupsMap.get(groupId);

		if (!group) {
			group = {
				id: groupId,
				description: apiImpediment.assignmentImpedimentGroup.designation,
				impediments: [],
			};
			groupsMap.set(groupId, group);
		}

		const impediment = transformApiImpedimentToAppImpediment(apiImpediment);
		group.impediments.push(impediment);
	});

	return Array.from(groupsMap.values());
}
